import React from 'react';
import {
BooleanField,DateField, Show,
ShowButton,List,ReferenceField,
Edit, Create, Datagrid,
 TextField, SimpleShowLayout, TabbedForm,FormTab, RichTextField, DateInput,NumberInput,BooleanInput,RichTextInput,
EditButton, DisabledInput, LongTextInput,SimpleForm, ReferenceInput, SelectInput, TextInput }
from 'admin-on-rest/lib/mui';

import { required,email,number,maxLength,minLength } from 'admin-on-rest';

const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateParser = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

export const UserList = (props) => (
    <List title="רשימת בתי עסק" perPage={30} {...props} >
    
        <Datagrid>
            <TextField source="id" label="#"/>
             <TextField source="name_heb" label="שם בית עסק"/>
             <TextField source="provider_number" label="מספר ספק"/>
             <TextField source="plan_name" label="תוכנית"/>
             <TextField source="phone" label="טלפון"/>
             <TextField source="email" label="מייל"/>
             <TextField source="join_date" label="ת. הצטרפות"/>
             <TextField source="agent_name" label="סוכן"/>

             

            <EditButton />
        </Datagrid>
    </List>
);

const UserTitle = ({ record }) => {
    return <span>{record ? `"${record.name_heb}"` : ''}</span>;
};


export const UserShow = (props) => (
    <Show title={<UserTitle />} {...props}>
 <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="email" label="אימייל" />
<TextField source="name_heb" label="שם בית העסק - עברית"/>
<TextField source="name_eng" label="שם בית העסק - אנגלית"/>
<TextField source="company_no" label="ח.פ./עוסק מורשה"/>
<TextField source="address" label="כתובת"/>
<TextField source="phone" label="טלפון"/>
<TextField source="cellular" label="נייד"/>
<TextField source="fax" label="פקס"/>
<TextField source="commercial_name" label="שם מסחרי"/>
<TextField source="website" label="אתר אינטרנט"/>
<TextField source="bank" />

<TextField source="bank_branch" label="סניף"/>
<TextField source="bank_account_number" label="מספר חשבון"/>
<TextField source="credit_card_number" label="מספר כרטיס אשראי"/>
<TextField source="validity_date" label="תוקף"/>
<TextField source="cvv" label="CVV"/>
<TextField source="card_owner" label="שם בעל הכרטיס"/>
<TextField source="card_owner_id" label="ת.ז."/>
<DateField source="join_date" label="ת. הצטרפות"/>
<TextField source="terminal_type" label="סוג מסוף"/>
<TextField source="terminal_name" label="שם מסוף"/>
<TextField source="terminal_number" label="מספר מסוף"/>
<TextField source="provider_number" label="מספר ספק"/>
<BooleanField source="cal_terminal_approved" label="כאל - אישור פתיחה"/>
<TextField source="plan_name" label="שם תוכנית"/>
<TextField source="monthly_cap" label="CAP חודשי"/>
<TextField source="setup_fee" label="עלות הקמה חד פעמית"/>
<TextField source="monthly_fee" label="עלות חודשית"/>
<TextField source="prepayment" label="שרות הקדמת תשלום"/>
<TextField source="invoices_plan" label="מודול הנפקת חשבוניות"/>
<TextField source="token" label="טוקן"/>
<TextField source="batch" label="BATCH"/>
<TextField source="additional_terminal_fee" label="חיוב בגין מסוף נוסף"/>
<TextField source="discount_payments" label="נכיון תשלומים"/>
<TextField source="promotional_date" label="מועדי זיכוי ללקוח"/>
<TextField source="cap_exception" label="חריגה מ CAP"/>
<TextField source="tourist_card_commision" label="עמלת כרטיס תייר"/>
<TextField source="cancel_transaction_commision" label="עמלת ביטול עסקה"/>
<TextField source="mismach_haser_commision" label="עמלת עסקה במסמך חסר"/>
<TextField source="payments_commision" label="עמלת עסקה בתשלומים"/>
<TextField source="additional_payments_commision" label="עמלת הוספת מועדי זיכוי"/>
<TextField source="hardware_fee" label="הספקת חומרה"/>
<TextField source="agent_name" label="Agent"/>


 </SimpleShowLayout>
    </Show>
);

export const UserEdit = (props) => (

<Edit title={<UserTitle />} {...props}>
        <TabbedForm >
            <FormTab label="כללי">
                <DisabledInput label="Id" source="id" />
                  <TextInput source="name_heb" label="שם בית העסק - עברית"/>
                  <TextInput source="email" label="אימייל"  validate={[ required, email  ]}/>
                  <TextInput source="name_eng" label="שם בית העסק - אנגלית"/>
                  <TextInput source="company_no" label="ח.פ./עוסק מורשה" validate={[ required ,maxLength (11)]}/>
                  <TextInput source="address" label="כתובת"/>
                  <TextInput source="phone" label="טלפון" validate={[  maxLength (11) ]}/>
                  <TextInput source="cellular" label="נייד" validate={[  minLength (10),maxLength (10) ]}/>
                  <TextInput source="fax" label="פקס" validate={[  maxLength (11) ]}/>
                  <TextInput source="commercial_name" label="שם מסחרי"/>
                  <TextInput source="website" label="אתר אינטרנט"/>
            </FormTab>
            <FormTab label="פרטי בנק">



                <ReferenceInput label="שם בנק" source="bank_id" reference="banks" allowEmpty>
        <SelectInput optionText="bank" />
    </ReferenceInput>

              <TextInput source="bank_branch" label="סניף"/>
              <TextInput source="bank_account_number" label="מספר חשבון"/>
            </FormTab>
            <FormTab label="כרטיס אשראי">
              <TextInput source="credit_card_number" label="מספר כרטיס אשראי" validate={[  maxLength (16) ]}/>
           

 

<DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="תוקף" source="validity_date" options={{
    mode: 'landscape',
    minDate: new Date(),
  
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>     


              <TextInput source="cvv" label="CVV" validate ={[number]}/>
              <TextInput source="card_owner" label="שם בעל הכרטיס"/>
              <TextInput source="card_owner_id" label="ת.ז."/>

            </FormTab>
            <FormTab label="תוכנית">
            
                <ReferenceInput label="שם תוכנית" source="plan_id"  reference="plans" allowEmpty>
        <SelectInput optionText="plan" />
    </ReferenceInput>

<ReferenceInput label="מספר ספק"
     source="provider_number2"
     reference="providernumbers" allowEmpty >
    <SelectInput optionText="provider_number" />
</ReferenceInput>

           <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת. הצטרפות" source="join_date" options={{
    mode: 'landscape',
    maxDate: new Date(),
  
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>     

     




                <ReferenceInput label="סוג מסוף" source="terminal_type" reference="terminaltypes" allowEmpty>
            <SelectInput optionText="name" />
            </ReferenceInput>
              <TextInput source="terminal_name" label="שם מסוף"/>
              <TextInput source="terminal_number" label="מספר מסוף"/>
              
              <BooleanInput source="cal_terminal_approved" label="כאל - אישור פתיחה"/>
              
             

     <ReferenceInput label="agent" source="agent_id" reference="agents" allowEmpty>
        <SelectInput optionText="name" />
    </ReferenceInput>
            </FormTab>
               <FormTab label="תוכנית - שינויים">
                   <ReferenceInput label="מועדי זיכוי" source="zicui_date_plan_id" reference="zicuidateplans" allowEmpty>
        <SelectInput optionText="name" />
    </ReferenceInput>

 <TextInput source="monthly_cap" label="CAP חודשי"/>
              <TextInput source="setup_fee" label="עלות הקמה חד פעמית"/>
              <TextInput source="monthly_fee" label="עלות חודשית"/>
              <TextInput source="prepayment" label="שרות הקדמת תשלום"/>
              <TextInput source="invoices_plan" label="מודול הנפקת חשבוניות"/>
              <TextInput source="token" label="טוקן"/>
              <TextInput source="batch" label="BATCH"/>
              <TextInput source="additional_terminal_fee" label="חיוב בגין מסוף נוסף"/>
              <TextInput source="discount_payments" label="נכיון תשלומים"/>
              <TextInput source="promotional_date" label="מועדי זיכוי ללקוח"/>
              <TextInput source="cap_exception" label="חריגה מ CAP"/>
              <TextInput source="tourist_card_commision" label="עמלת כרטיס תייר"/>
              <TextInput source="cancel_transaction_commision" label="עמלת ביטול עסקה"/>
              <TextInput source="mismach_haser_commision" label="עמלת עסקה במסמך חסר"/>
              <TextInput source="payments_commision" label="עמלת עסקה בתשלומים"/>
              <TextInput source="additional_payments_commision" label="עמלת הוספת מועדי זיכוי"/>
              <TextInput source="hardware_fee" label="הספקת חומרה"/>
                     </FormTab>
        </TabbedForm>
    </Edit>
);



const createValidation = (values) => {
    const errors = {};
   
    if (values.cvv && values.cvv.length!=3) {
        errors.cvv = ['cvv only 3 digits'];
    }
    return errors
};


const filt = ({ record }) => {
    //return {active:0}
    
    return searchText => ({ active: 0 })
};
export const UserCreate = (props) => (
    <Create title="הוספת לקוח חדש" {...props}>
      <TabbedForm  >
          <FormTab label="כללי">
              <DisabledInput label="Id" source="id" />
                <TextInput source="name_heb" label="שם בית העסק - עברית"/>
                <TextInput source="email" label="אימייל" validate={[ required, email ]}/>
                <TextInput source="name_eng" label="שם בית העסק - אנגלית"/>
                <TextInput source="company_no" label="ח.פ./עוסק מורשה"  validate={[ required ,maxLength (11)]}/>

                  <ReferenceInput label="סוכן מגייס" source="agent_id" reference="agents" allowEmpty>
               <SelectInput optionText="name" />
               </ReferenceInput>

                <TextInput source="address" label="כתובת"/>
                <TextInput source="phone" label="טלפון" validate={[  maxLength (11) ]}/>
                <TextInput source="cellular" label="נייד" validate={[  minLength (10),maxLength (10) ]}/>
                <TextInput source="fax" label="פקס" validate={[  maxLength (11) ]}/>
                <TextInput source="commercial_name" label="שם מסחרי"/>
                <TextInput source="website" label="אתר אינטרנט"/>
          </FormTab>
          <FormTab label="פרטי בנק">
            <ReferenceInput label="שם בנק" source="bank_id" reference="banks" allowEmpty>
    <SelectInput optionText="bank" />
</ReferenceInput>

            <TextInput source="bank" label="בנק" />
            <TextInput source="bank_branch" label="סניף"/>
            <TextInput source="bank_account_number" label="מספר חשבון"/>
          </FormTab>
          <FormTab label="כרטיס אשראי">
            <TextInput source="credit_card_number" label="מספר כרטיס אשראי"/>
            <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="תוקף" source="validity_date" options={{
    mode: 'landscape',
    minDate: new Date(),
  
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>     

            <TextInput source="cvv" label="CVV"/>
            <TextInput source="card_owner" label="שם בעל הכרטיס"/>
            <TextInput source="card_owner_id" label="ת.ז."/>

          </FormTab>
          <FormTab label="תוכנית">
               <ReferenceInput label="שם תוכנית" source="plan_id" reference="plans" allowEmpty>
        <SelectInput optionText="plan" />
    </ReferenceInput>

    <ReferenceInput label="מספר ספק" source="provider_number" reference="providernumbers" filterToQuery={filt} allowEmpty>
        <SelectInput optionText="provider_number" />
    </ReferenceInput>

          

     <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת. הצטרפות" source="join_date" options={{
    mode: 'landscape',
    maxDate: new Date(),
  
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>     


     


              <ReferenceInput label="סוג מסוף" source="terminal_type" reference="terminaltypes" allowEmpty>
            <SelectInput optionText="name" />
            </ReferenceInput>

            <TextInput source="terminal_name" label="שם מסוף"/>
            <TextInput source="terminal_number" label="מספר מסוף"/>


         


<BooleanInput label="כאל - אישור פתיחה" source="cal_terminal_approved" />

            
            

  <ReferenceInput label="zicui_date_plan_id" source="zicui_date_plan_id" reference="zicuidateplans" allowEmpty>
<SelectInput optionText="name" />
</ReferenceInput>

   </FormTab>
               <FormTab label="תוכנית - שינויים">
<TextInput source="monthly_cap" label="CAP חודשי"/>
            <TextInput source="setup_fee" label="עלות הקמה חד פעמית"/>
            <TextInput source="monthly_fee" label="עלות חודשית"/>
            <TextInput source="prepayment" label="שרות הקדמת תשלום"/>
            <TextInput source="invoices_plan" label="מודול הנפקת חשבוניות"/>
            <TextInput source="token" label="טוקן"/>
            <TextInput source="batch" label="BATCH"/>
            <TextInput source="additional_terminal_fee" label="חיוב בגין מסוף נוסף"/>
            <TextInput source="discount_payments" label="נכיון תשלומים"/>
            <TextInput source="promotional_date" label="מועדי זיכוי ללקוח"/>
            <TextInput source="cap_exception" label="חריגה מ CAP"/>
            <TextInput source="tourist_card_commision" label="עמלת כרטיס תייר"/>
            <TextInput source="cancel_transaction_commision" label="עמלת ביטול עסקה"/>
            <TextInput source="mismach_haser_commision" label="עמלת עסקה במסמך חסר"/>
            <TextInput source="payments_commision" label="עמלת עסקה בתשלומים"/>
            <TextInput source="additional_payments_commision" label="עמלת הוספת מועדי זיכוי"/>
            <TextInput source="hardware_fee" label="הספקת חומרה"/>


<TextInput source="total_transactions_limit" label="total_transactions_limit"/>
          </FormTab>
      </TabbedForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/User/user.js